import { CUSTOM_EVENTS, useEventListener } from '@register-ui/utils';
import { useMemo, useState } from 'react';
import { type BannerVariant } from '../types';
import { STOCK_SYNC_STATUS, type StockSyncStatus } from './types';

export const SUCCESSFUL_SYNC_BANNER_DURATION = 3000;

export function useStockSyncIndicator() {
    const [status, setStatus] = useState<StockSyncStatus>(
        STOCK_SYNC_STATUS.IDLE,
    );

    useEventListener(CUSTOM_EVENTS.ITEM_STOCK_SYNC_STARTED, () => {
        setStatus(STOCK_SYNC_STATUS.STARTED);
    });

    useEventListener(CUSTOM_EVENTS.ITEM_STOCK_SYNC_SUCCESS, () => {
        setStatus(STOCK_SYNC_STATUS.SUCCESS);

        setTimeout(() => {
            setStatus(STOCK_SYNC_STATUS.IDLE);
        }, SUCCESSFUL_SYNC_BANNER_DURATION);
    });

    useEventListener(CUSTOM_EVENTS.ITEM_STOCK_SYNC_FAILED, () => {
        setStatus(STOCK_SYNC_STATUS.FAILED);
    });

    const stockVariant: BannerVariant = useMemo(() => {
        switch (status) {
            case STOCK_SYNC_STATUS.SUCCESS: {
                return 'success';
            }
            case STOCK_SYNC_STATUS.FAILED: {
                return 'error';
            }
            default: {
                return 'info';
            }
        }
    }, [status]);

    const showStockBanner: boolean = (
        [
            STOCK_SYNC_STATUS.FAILED,
            STOCK_SYNC_STATUS.STARTED,
            STOCK_SYNC_STATUS.SUCCESS,
        ] as StockSyncStatus[]
    ).includes(status);

    return { stockStatus: status, stockVariant, showStockBanner };
}
